/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  margin-top: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY3VzdG9tLWF1dG9jb21wbGV0ZS9jb21wb25lbnRzL2F1dG9jb21wbGV0ZS1jYW5kaWRhdGUtZGlzYWJpbGl0eS9hdXRvY29tcGxldGUtY2FuZGlkYXRlLWRpc2FiaWxpdHkuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY3VzdG9tLWF1dG9jb21wbGV0ZS9jb21wb25lbnRzL2F1dG9jb21wbGV0ZS1jYW5kaWRhdGUtZGlzYWJpbGl0eS9hdXRvY29tcGxldGUtY2FuZGlkYXRlLWRpc2FiaWxpdHkuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/custom-autocomplete/components/autocomplete-candidate-disability/autocomplete-candidate-disability.component.scss.shim.ngstyle.ts